import addLeaveRequest from './addLeaveRequest'
import leaveRequestServiceConfigs from './configs'
import getFileNameFromRef from './getFileNameFromRef'
import getLeaveRequestById from './getLeaveRequestById'
import getRespondedLeaveRequests from './getRespondedLeaveRequests'
import getUnrespondedLeaveRequests from './getUnrespondedLeaveRequests'
import setApprovalLeaveRequestById from './setApprovalLeaveRequestById'
import updateLeaveRequestById from './updateLeaveRequestById'

const LeaveRequestService = {
  configs: leaveRequestServiceConfigs,
  add: addLeaveRequest,
  getUnresponded: getUnrespondedLeaveRequests,
  getResponded: getRespondedLeaveRequests,
  getById: getLeaveRequestById,
  getFileNameFromRef,
  setApprovalById: setApprovalLeaveRequestById,
  update: updateLeaveRequestById,
}

export default LeaveRequestService
